/* eslint-disable react/no-unused-state */
import { useState, useEffect, Suspense } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CInput,
  CButton,
  CLabel,
  CSelect
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Prompt } from "react-router-dom";
import { bindActionCreators } from "redux";

import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

const ADROriginCreate = props => {
  const [origin, setOrigin] = useState({
    id: 0,
    name: "",
    year: "",
    is_active: false
  });
  const [edit, setEdit] = useState(false);
  const [creating, setCreating] = useState(false);
  const { id } = props.match.params;

  const error = response => {
    if (response === "Unauthorized") {
      props.logout(props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  };

  useEffect(() => {
    props.setObj(16, props.currentRoute, props.currentRoute);
    (async () => {
      if (id) {
        await checkEdit();
      }
    })();
  }, []);

  const checkEdit = async () => {
    await axios
      .get(`${URL.api}adr/origins/singleView/${id}`, {
        headers: { authorization: `Bearer ${props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          setOrigin(resp.data.data);
          setEdit(true);
          setCreating(true);
        }
      });
  };

  const handleChange = event => {
    const { name, value } = event.target;

    setOrigin(prevState => ({
      ...prevState,
      [name]: value
    }));
    setCreating(true);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!origin.name || !origin.year) {
      toastr.error("Falha", "Preencha todos os campos");
      return;
    }

    const obj = {
      name: origin.name,
      year: parseInt(origin.year, 10)
    };

    try {
      await axios.post(`${URL.api}adr/origins/insert`, obj, {
        headers: { authorization: `Bearer ${props.user.token}` }
      });

      props.history.push("/adr/origins/");
      setCreating(true);
    } catch (err) {
      error(err.response.data.message);
    }
  };

  const handleUpdate = async e => {
    e.preventDefault();

    if (!origin.name || !origin.year) {
      toastr.error("Falha", "Preencha todos os campos");
      return;
    }

    const obj = {
      id: origin.id,
      name: origin.name,
      year: parseInt(origin.year, 10),
      is_active: origin.is_active === "true"
    };

    try {
      await axios.post(`${URL.api}adr/origins/update`, obj, {
        headers: { authorization: `Bearer ${props.user.token}` }
      });

      props.history.push("/adr/origins/");
      setCreating(true);
    } catch (err) {
      error(err.response.data.message);
    }
  };

  return (
    <>
      <Prompt
        when={creating}
        message="Os dados do formulário ainda não foram salvos. Tem certeza de que deseja sair desta página?"
      />
      <Breadcrumb
        current={props.currentRoute}
        items={[{ path: "/adr/origins/", to: "/adr/origins/" }]}
      />
      <Suspense fallback={<Loading />}>
        <CCard>
          <CCardHeader className="d-flex align-items-center">
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <h4 className="card-title mb-1">
                {edit ? "Editar " : "Criar "}
                origem ADR
              </h4>
              <div className="small text-muted">
                {edit ? "Edite a origem selecionado" : "Crie uma nova origem"}
              </div>
            </div>
            <CButton
              color="primary"
              className="d-flex justify-content-center align-items-center"
              onClick={edit ? handleUpdate : handleSubmit}
            >
              Salvar
            </CButton>
          </CCardHeader>
          <CCardBody>
            <CFormGroup>
              <CLabel>Nome</CLabel>
              <CInputGroup>
                <CInputGroupPrepend>
                  <CInputGroupText>
                    <i className="fa fa-text-width"></i>
                  </CInputGroupText>
                </CInputGroupPrepend>
                <CInput
                  type="text"
                  name="name"
                  value={origin.name}
                  onChange={handleChange}
                  placeholder="Nome"
                />
              </CInputGroup>
            </CFormGroup>
            <CFormGroup>
              <CLabel>Ano</CLabel>
              <CInputGroup>
                <CInputGroupPrepend>
                  <CInputGroupText>
                    <i className="fa fa-text-width"></i>
                  </CInputGroupText>
                </CInputGroupPrepend>
                <CSelect
                  type="select"
                  name="year"
                  value={origin.year}
                  onChange={handleChange}
                  placeholder="Selecione o ano"
                >
                  <option value="">Selecione o ano</option>
                  {[2024, 2025, 2026].map(year => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </CSelect>
              </CInputGroup>
            </CFormGroup>
            <CFormGroup hidden={!edit}>
              <CLabel>Status</CLabel>
              <CInputGroup>
                <CInputGroupPrepend>
                  <CInputGroupText>
                    <i className="fa fa-text-width"></i>
                  </CInputGroupText>
                </CInputGroupPrepend>
                <CSelect
                  type="text"
                  name="is_active"
                  value={origin.is_active}
                  onChange={handleChange}
                  placeholder="Status"
                >
                  {[
                    { label: "Ativo", value: true },
                    { label: "Desativado", value: false }
                  ].map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </CSelect>
              </CInputGroup>
            </CFormGroup>
          </CCardBody>
        </CCard>
      </Suspense>
      <ProtectedRoute routeId={props.currentRoute} />
    </>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setObj }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ADROriginCreate);
